var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable react/function-component-definition */
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Chip from '@mui/material/Chip';
import Alert from '@mui/material/Alert';
import Paper from '@mui/material/Paper';
import LoadingButton from '@mui/lab/LoadingButton';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import QrCodeScannerIcon from '@mui/icons-material/QrCodeScanner';
import TvIcon from '@mui/icons-material/Tv';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import SettingsIcon from '@mui/icons-material/Settings';
import SportsEsportsIcon from '@mui/icons-material/SportsEsports';
import HowToRegIcon from '@mui/icons-material/HowToReg';
import PersonSearchIcon from '@mui/icons-material/PersonSearch';
import { useQuery } from '../../hooks';
import { MatchPlayers } from '../../components/organisms/MatchPlayers';
import { loadMatch, verifyMatchPayment, getTemplateTypes, loadEvents } from '../../api';
import { EMatchStatus } from '../../types';
import { Alerts } from '../../components/molecules/Alerts/Alerts';
import { ModalNew } from '../../components/atoms/Modal/Modal';
import { AddPlayers } from '../../components/organisms/AddPlayers/AddPlayers';
import { CopyPlayers } from '../../components/molecules/CopyPlayers/CopyPlayers';
import { useAsyncExecAction } from '../../hooks/useAsyncExecAction';
import { MatchStart } from '../../components/molecules/MatchStart/MatchStart';
import JoinQrCodeReader from '../../components/organisms/JoinQrCodeReader/JoinQrCodeReader';
import * as api from '../../api';
import { getPlayersWithUnknownSource } from '../../api/events';
import { AdditionalGameInvoiceButton } from '../../components/molecules/AdditionalGameInvoiceButton';
import { colors } from '../../styles/colors';
import { Breadcrumbs } from '../../components/atoms/Breadcrumbs';
import { GuestCodeModal } from '../../features/guestCode';
import { ScreenPairDialog } from '../../features/screenPairing';
export const MatchConfig = () => {
    var _a;
    const nav = useNavigate();
    const { param: matchId } = useQuery('matchId');
    const { param: fixSeating } = useQuery('fixSeating');
    const [match, setMatch] = useState(null);
    const [showQrScan, setShowQrScan] = useState(false);
    const [viewAddPlayers, setViewAddPlayers] = useState(false);
    const [viewCopyPlayers, setViewCopyPlayers] = useState(false);
    const [matchStart, setMatchStart] = useState(false);
    const [showGuestCodeModal, setShowGuestCodeModal] = useState(false);
    const [showScreenPair, setShowScreenPair] = useState(false);
    const [forceAdjustOrder, setForceAdjustOrder] = useState(false);
    const [playersChanged, setPlayersChanged] = useState(false);
    const [disabled, setDisabled] = useState(false);
    const [isAddingBooked, setIsAddingBooked] = useState(false);
    const [showFixSeatingHint, setShowFixSeatingHint] = useState(false);
    const [templateTypes, setTemplateTypes] = useState([]);
    const [unknownSourcePlayerIds, setUnknownSourcePlayerIds] = useState([]);
    const [event, setEvent] = useState(null);
    const { execAsyncAction } = useAsyncExecAction();
    const loadMatchData = () => __awaiter(void 0, void 0, void 0, function* () {
        const result = yield loadMatch(matchId || '');
        setMatch(result);
    });
    useEffect(() => {
        if (!matchId)
            return;
        const getInitialData = () => __awaiter(void 0, void 0, void 0, function* () {
            yield execAsyncAction({ action: loadMatchData });
        });
        getInitialData();
    }, [matchId]);
    useEffect(() => {
        if (fixSeating === 'true') {
            setShowFixSeatingHint(true);
        }
    }, [fixSeating]);
    useEffect(() => {
        const loadTemplateTypesData = () => __awaiter(void 0, void 0, void 0, function* () {
            try {
                const response = yield getTemplateTypes();
                setTemplateTypes(response.types);
            }
            catch (error) {
                console.error('Failed to load template types:', error);
            }
        });
        loadTemplateTypesData();
    }, []);
    // Load unknown source player IDs when match is loaded or players changed
    useEffect(() => {
        const loadUnknownSourcePlayers = () => __awaiter(void 0, void 0, void 0, function* () {
            if (!(match === null || match === void 0 ? void 0 : match.eventId))
                return;
            try {
                const response = yield getPlayersWithUnknownSource(match.eventId);
                setUnknownSourcePlayerIds(response.players.map((p) => p.id));
            }
            catch (error) {
                console.error('Failed to load unknown source players:', error);
            }
        });
        loadUnknownSourcePlayers();
    }, [match === null || match === void 0 ? void 0 : match.eventId, playersChanged]);
    // Load event for breadcrumbs
    useEffect(() => {
        const loadEventData = () => __awaiter(void 0, void 0, void 0, function* () {
            if (!(match === null || match === void 0 ? void 0 : match.eventId))
                return;
            try {
                const response = yield loadEvents();
                const foundEvent = response.events.find((e) => e.id === match.eventId);
                if (foundEvent) {
                    setEvent(foundEvent);
                }
            }
            catch (error) {
                console.error('Failed to load event:', error);
            }
        });
        loadEventData();
    }, [match === null || match === void 0 ? void 0 : match.eventId]);
    const onClickAddPlayers = () => {
        setViewAddPlayers(true);
    };
    const onClickCloseAddPlayers = () => {
        setViewAddPlayers(false);
    };
    const onClickBack = () => {
        if (match)
            nav(`/matches?eventId=${match.eventId}`);
    };
    const verifyPaymentAction = () => __awaiter(void 0, void 0, void 0, function* () {
        yield verifyMatchPayment(matchId || '');
    });
    const onClickStartMatch = () => __awaiter(void 0, void 0, void 0, function* () {
        if ((match === null || match === void 0 ? void 0 : match.status) === EMatchStatus.INGAME) {
            nav(`/match?matchId=${matchId}`);
        }
        if ((match === null || match === void 0 ? void 0 : match.status) === EMatchStatus.ENDED) {
            nav(`/match?matchId=${matchId}`);
        }
        const pay = yield execAsyncAction({ action: verifyPaymentAction });
        if (pay) {
            setMatchStart(true);
        }
    });
    const executeMatchStart = () => __awaiter(void 0, void 0, void 0, function* () {
        setMatchStart(false);
        if (match) {
            nav(`/match?matchId=${match === null || match === void 0 ? void 0 : match.id}`);
        }
    });
    const onMatchStartClose = () => __awaiter(void 0, void 0, void 0, function* () {
        setMatchStart(false);
    });
    const onClickCopyPlayers = () => {
        setViewCopyPlayers(true);
    };
    const onClickCloseCopyPlayers = () => {
        setViewCopyPlayers(false);
    };
    const onShowQrClick = () => {
        setShowQrScan(true);
    };
    const getTemplateTypeName = (templateTypeId) => {
        if (!templateTypeId)
            return null;
        const templateType = templateTypes.find((t) => t.id === templateTypeId);
        return (templateType === null || templateType === void 0 ? void 0 : templateType.name) || null;
    };
    const onClickViewTemplates = () => {
        nav('/template-types');
    };
    const handleAddBookedPlayers = () => __awaiter(void 0, void 0, void 0, function* () {
        if (!matchId)
            return;
        setIsAddingBooked(true);
        yield execAsyncAction({
            action: () => __awaiter(void 0, void 0, void 0, function* () {
                yield api.addBookedPlayers(matchId);
                const newMatch = yield loadMatch(matchId);
                setMatch(newMatch);
                setPlayersChanged(true);
            }),
            final: () => setIsAddingBooked(false),
        });
    });
    const getStartButtonText = () => {
        if ((match === null || match === void 0 ? void 0 : match.status) === EMatchStatus.CREATED)
            return 'Начать игру';
        if ((match === null || match === void 0 ? void 0 : match.status) === EMatchStatus.INGAME)
            return 'Перейти к игре';
        if ((match === null || match === void 0 ? void 0 : match.status) === EMatchStatus.ENDED)
            return 'Перейти к статистике';
        return 'Начать игру';
    };
    return (_jsxs(Box, Object.assign({ sx: {
            minHeight: '100vh',
            backgroundColor: colors.background,
            padding: '24px',
        } }, { children: [_jsxs(Box, Object.assign({ sx: {
                    maxWidth: '1000px',
                    margin: '0 auto',
                } }, { children: [_jsx(Alerts, {}), showQrScan && (_jsx(ModalNew, Object.assign({ onClose: () => setShowQrScan(false) }, { children: _jsx(JoinQrCodeReader, { onClose: () => setShowQrScan(false), onPlayerFound: (playerId) => __awaiter(void 0, void 0, void 0, function* () {
                                yield execAsyncAction({
                                    action: () => __awaiter(void 0, void 0, void 0, function* () {
                                        yield api.addPlayersToMatch({
                                            matchId,
                                            data: [playerId],
                                        });
                                        setPlayersChanged(true);
                                    }),
                                });
                            }), onRefCodeFound: (code) => __awaiter(void 0, void 0, void 0, function* () {
                                yield execAsyncAction({
                                    action: () => __awaiter(void 0, void 0, void 0, function* () {
                                        yield api.addPlayerByRefCode(matchId || '', code);
                                        setPlayersChanged(true);
                                    }),
                                });
                            }) }) }))), viewAddPlayers && (_jsx(ModalNew, Object.assign({ onClose: onClickCloseAddPlayers, close: true }, { children: _jsx(AddPlayers, { matchId: matchId, setPlayersChanged: setPlayersChanged, onClose: onClickCloseAddPlayers }) }))), viewCopyPlayers && (_jsx(ModalNew, Object.assign({ onClose: onClickCloseCopyPlayers, close: true }, { children: _jsx(CopyPlayers, { match: match, setPlayersChanged: setPlayersChanged, onClose: onClickCloseCopyPlayers }) }))), matchStart && (_jsx(ModalNew, Object.assign({ onClose: onMatchStartClose, close: true }, { children: _jsx(MatchStart, { onStart: executeMatchStart, onSetOrder: () => setForceAdjustOrder(true), onClose: onMatchStartClose }) }))), _jsx(GuestCodeModal, { open: showGuestCodeModal, onClose: () => setShowGuestCodeModal(false), matchId: matchId !== null && matchId !== void 0 ? matchId : undefined, eventId: (_a = match === null || match === void 0 ? void 0 : match.eventId) !== null && _a !== void 0 ? _a : undefined }), _jsx(Breadcrumbs, { items: [
                            { label: 'Афиши', path: '/' },
                            { label: (event === null || event === void 0 ? void 0 : event.name) || 'Игры', path: (match === null || match === void 0 ? void 0 : match.eventId) ? `/matches?eventId=${match.eventId}` : undefined },
                            { label: (match === null || match === void 0 ? void 0 : match.name) || 'Настройка игры' },
                        ] }), _jsx(Box, Object.assign({ sx: {
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'flex-start',
                            marginBottom: '24px',
                            gap: '16px',
                            flexWrap: 'wrap',
                        } }, { children: _jsxs(Box, Object.assign({ sx: { display: 'flex', alignItems: 'center', gap: '16px' } }, { children: [_jsx(IconButton, Object.assign({ onClick: onClickBack, sx: {
                                        backgroundColor: colors.surfaceVariant,
                                        '&:hover': {
                                            backgroundColor: colors.secondaryLight,
                                        },
                                    } }, { children: _jsx(ArrowBackIcon, {}) })), _jsxs(Box, { children: [_jsxs(Box, Object.assign({ sx: { display: 'flex', alignItems: 'center', gap: '12px' } }, { children: [_jsx(SportsEsportsIcon, { sx: { fontSize: 28, color: colors.primary } }), _jsx(Typography, Object.assign({ variant: "h4" }, { children: (match === null || match === void 0 ? void 0 : match.name) || 'Загрузка...' }))] })), _jsxs(Box, Object.assign({ sx: { display: 'flex', gap: '8px', marginTop: '12px', flexWrap: 'wrap' } }, { children: [(match === null || match === void 0 ? void 0 : match.isManualDistribution) !== undefined && (_jsx(Chip, { icon: _jsx(SettingsIcon, { sx: { fontSize: 16 } }), label: match.isManualDistribution ? 'Ручная раздача' : 'Автоматическая раздача', color: match.isManualDistribution ? 'warning' : 'info', variant: "outlined", size: "small" })), !(match === null || match === void 0 ? void 0 : match.isManualDistribution) && (match === null || match === void 0 ? void 0 : match.distributionTemplateTypeId) && (_jsx(Chip, { label: `Шаблон: ${getTemplateTypeName(match.distributionTemplateTypeId) || 'Загрузка...'}`, color: "info", variant: "outlined", size: "small" }))] }))] })] })) })), showFixSeatingHint && (_jsx(Alert, Object.assign({ severity: "info", sx: { marginBottom: '24px' } }, { children: "\u0418\u0437\u043C\u0435\u043D\u0438\u0442\u0435 \u043F\u043E\u0440\u044F\u0434\u043E\u043A \u0438\u0433\u0440\u043E\u043A\u043E\u0432, \u043F\u0435\u0440\u0435\u0442\u0430\u0441\u043A\u0438\u0432\u0430\u044F \u0438\u0445 \u0432 \u0442\u0430\u0431\u043B\u0438\u0446\u0435. \u041F\u043E\u0441\u043B\u0435 \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u044F \u043D\u0430\u0436\u043C\u0438\u0442\u0435 \"\u0412\u0435\u0440\u043D\u0443\u0442\u044C\u0441\u044F \u0432 \u0438\u0433\u0440\u0443\"" }))), fixSeating === 'true' && (match === null || match === void 0 ? void 0 : match.status) === EMatchStatus.INGAME && (_jsx(Box, Object.assign({ sx: { marginBottom: '24px' } }, { children: _jsx(Button, Object.assign({ variant: "contained", color: "success", size: "large", startIcon: _jsx(PlayArrowIcon, {}), onClick: () => nav(`/match?matchId=${matchId}`) }, { children: "\u0412\u0435\u0440\u043D\u0443\u0442\u044C\u0441\u044F \u0432 \u0438\u0433\u0440\u0443" })) }))), _jsxs(Box, Object.assign({ sx: {
                            display: 'grid',
                            gridTemplateColumns: { xs: '1fr', md: '1fr 300px' },
                            gap: '24px',
                            alignItems: 'flex-start',
                        } }, { children: [_jsx(Box, { children: _jsx(MatchPlayers, { matchId: matchId, changed: playersChanged, setChanged: setPlayersChanged, forceAdjustWindowOpened: forceAdjustOrder, orderSet: () => setForceAdjustOrder(false), setDisabled: setDisabled, unknownSourcePlayerIds: unknownSourcePlayerIds }) }), _jsxs(Paper, Object.assign({ sx: {
                                    padding: '24px',
                                    height: 'fit-content',
                                    position: { md: 'sticky' },
                                    top: { md: '24px' },
                                } }, { children: [_jsx(Typography, Object.assign({ variant: "h6", sx: { marginBottom: '20px' } }, { children: "\u0414\u0435\u0439\u0441\u0442\u0432\u0438\u044F" })), _jsxs(Box, Object.assign({ sx: { display: 'flex', flexDirection: 'column', gap: '12px' } }, { children: [_jsx(LoadingButton, Object.assign({ variant: "contained", fullWidth: true, loading: !match, startIcon: _jsx(PlayArrowIcon, {}), onClick: onClickStartMatch, disabled: disabled, sx: {
                                                    padding: '14px 24px',
                                                    fontSize: '15px',
                                                } }, { children: getStartButtonText() })), _jsx(Box, { sx: { height: '8px' } }), _jsx(Button, Object.assign({ variant: "outlined", color: "primary", fullWidth: true, startIcon: _jsx(HowToRegIcon, {}), onClick: handleAddBookedPlayers, disabled: disabled || isAddingBooked }, { children: isAddingBooked ? 'Добавление...' : 'Добавить записанных' })), _jsx(Button, Object.assign({ variant: "outlined", fullWidth: true, startIcon: _jsx(PersonSearchIcon, {}), onClick: onClickAddPlayers, disabled: disabled }, { children: "\u041D\u0430\u0439\u0442\u0438 \u0438 \u0434\u043E\u0431\u0430\u0432\u0438\u0442\u044C" })), _jsx(Button, Object.assign({ variant: "outlined", fullWidth: true, startIcon: _jsx(QrCodeScannerIcon, {}), onClick: onShowQrClick, disabled: disabled }, { children: "\u0421\u043A\u0430\u043D\u0438\u0440\u043E\u0432\u0430\u0442\u044C QR \u043A\u043E\u0434" })), _jsx(Button, Object.assign({ variant: "outlined", fullWidth: true, startIcon: _jsx(PersonAddIcon, {}), onClick: () => setShowGuestCodeModal(true), disabled: disabled || !match }, { children: "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0433\u043E\u0441\u0442\u044F \u043F\u043E \u043A\u043E\u0434\u0443" })), _jsx(Button, Object.assign({ variant: "outlined", fullWidth: true, startIcon: _jsx(ContentCopyIcon, {}), onClick: onClickCopyPlayers, disabled: disabled }, { children: "\u0421\u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0438\u0437 \u043F\u0440\u043E\u0448\u043B\u043E\u0439" })), _jsx(AdditionalGameInvoiceButton, { match: match, disabled: disabled }), _jsx(Button, Object.assign({ variant: "outlined", fullWidth: true, startIcon: _jsx(TvIcon, {}), onClick: () => setShowScreenPair(true) }, { children: "\u041F\u043E\u0434\u043A\u043B\u044E\u0447\u0438\u0442\u044C \u044D\u043A\u0440\u0430\u043D" }))] }))] }))] }))] })), _jsx(ScreenPairDialog, { open: showScreenPair, onClose: () => setShowScreenPair(false), matchId: matchId || null })] })));
};
